// Languages the backends accept for a customer's e-mails: ignite-hub
// reservations/serializers_input.py LOCALES and sale_api
// order/order/views_online.py LOCALES — the same eight. The site offers ja/ar
// too and picks the browser language on its own; sending those made the
// backend answer 400, and the booking (DF-0506) or the order (DF-0574) was
// lost. Anything else falls back to French, the e-mail default.
const BACKEND_LANGUAGES: readonly string[] = ['de', 'en', 'es', 'fr', 'it', 'nl', 'pt', 'zh'];

export function backendLanguage(language: string | undefined): string {
  return language && BACKEND_LANGUAGES.includes(language) ? language : 'fr';
}
